<template>
  <div>
    <b-card title="
    پیام جدید">
    <b-alert :show="errors.length > 0" variant="danger">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-card-text>
        <div>
          <b-form @submit="onSubmit" >
            <b-row>
               <b-col>
              <user-list :multiSelect=true v-model="form.user_id"></user-list>
            </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-2"
                  label="نوع پیام:"
                  label-for="input-2"
                >
                  <b-form-select required v-model="form.type" :options="options_type"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                 <b-form-group
                  id="input-group-2"
                  label="نحوه نمایش:"
                  label-for="input-2"
                >
                  <b-form-select  required
 v-model="form.dismissible" :options="options_dismissible"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-2"
                  label="متن پیام:"
                  label-for="input-2"
                >
              <b-form-textarea
                    v-model="form.description"
                    placeholder="متن پیام"
                    rows="3"
                    max-rows="6"
                    required
                  ></b-form-textarea>
                    </b-form-group>
              </b-col>
            </b-row>


            <b-button class="mt-3" type="submit" variant="primary"
              >ذخیره</b-button
            >
            <b-button class="mt-3 ml-3" href="#/messages" variant="danger"
              >بازگشت</b-button
            >
          </b-form>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";
import UserList from "../../components/UserList";

export default {
  name: "addMessage",
  components: {
    "user-list": UserList,
  },
  data() {
    return {
      errors: [],
      form: {
        user_id: [],
        description: "",
        type: "",
        dismissible: 0,
        location: 0,
      },
      options_type: [
          { value: 'success', text: 'موفق' },
          { value: 'error', text: 'خطا' },
        ],
        options_dismissible: [
          { value: 0, text: 'نمایش برای یکبار' },
          { value: 1, text: 'نمایش دایمی' },
        ]
    };
  },
  created() {
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      httpHelper.setAuth();
      httpHelper.postData("message", this.form).then((res) => {
          if (res.success) {
            this.$router.push("messages");
          } else {
            for (const key in res.error) {
              if (res.error.hasOwnProperty(key)) {
                const element = res.error[key];
                element.forEach((er) => {
                  this.errors.push(er);
                });
              }
            }
          }
      });
    },
   
  },
   mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: "پیام ها",
          route: "/messsages",
        },
        {
          title: "پیام جدید",
        },
      ]);
    },
};
</script>